module.exports = __webpack_public_path__ + "img/2722ae5d94004613a1591ecdd3e6635c.4c5b75ff.jpg";